import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import PropTypes from 'prop-types';

var DownloadFileComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(DownloadFileComponent, _Component);

  function DownloadFileComponent() {
    _classCallCheck(this, DownloadFileComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(DownloadFileComponent).apply(this, arguments));
  }

  _createClass(DownloadFileComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          displayNotes = _this$props.displayNotes;
      return React.createElement('a', {
        className: 'FileDescriptor',
        notranslate: 'true',
        href: "/form-files/".concat(displayNotes),
        target: '_blank'
      }, React.createElement('i', {
        className: 'icon-ic_file FileDescriptor-file-icon'
      }), React.createElement('span', {
        className: 'FileDescriptor-file-name downloadable'
      }, label));
    }
  }]);

  return DownloadFileComponent;
}(Component);

DownloadFileComponent.propTypes = {
  label: PropTypes.element.isRequired,
  displayNotes: PropTypes.string.isRequired
};
export default DownloadFileComponent;